/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditEntryDto
 */
export interface AuditEntryDto {
    /**
     * ID of the audit event (a group of changes saved together)
     * @type {number}
     * @memberof AuditEntryDto
     */
    eventId: number;
    /**
     * Timestamp when the change was recorded (UTC)
     * @type {Date}
     * @memberof AuditEntryDto
     */
    createdAt: Date;
    /**
     * User or system that performed the change
     * @type {string}
     * @memberof AuditEntryDto
     */
    createdBy: string;
    /**
     * Type of the changed entity, e.g. 'SystemProperty' or 'DunningSelectionConfiguration'
     * @type {string}
     * @memberof AuditEntryDto
     */
    entityType: string;
    /**
     * Identifier of the concrete entity instance. May be empty if there is only one instance.
     * @type {string}
     * @memberof AuditEntryDto
     */
    entityId?: string;
    /**
     * Technical field name that was changed
     * @type {string}
     * @memberof AuditEntryDto
     */
    field: string;
    /**
     * Display-friendly field name (may be equal to 'field' or computed by the mapper)
     * @type {string}
     * @memberof AuditEntryDto
     */
    subject: string;
    /**
     * Original value as stored. May be null.
     * @type {string}
     * @memberof AuditEntryDto
     */
    oldValue?: string;
    /**
     * New value as stored. May be null.
     * @type {string}
     * @memberof AuditEntryDto
     */
    newValue?: string;
    /**
     * Value type hint for UI, e.g. 'PLAIN' or 'UUID_LIST'
     * @type {string}
     * @memberof AuditEntryDto
     */
    valueType: string;
    /**
     * Optional dictionary name for resolving human-readable labels, e.g. 'rules' or 'rulesets'
     * @type {string}
     * @memberof AuditEntryDto
     */
    dictionary?: string;
    /**
     * Old value already formatted for display (e.g. '-1' -> '' or UUIDs -> names). May be null.
     * @type {string}
     * @memberof AuditEntryDto
     */
    oldValueDisplay?: string;
    /**
     * New value already formatted for display. May be null.
     * @type {string}
     * @memberof AuditEntryDto
     */
    newValueDisplay?: string;
}

/**
 * Check if a given object implements the AuditEntryDto interface.
 */
export function instanceOfAuditEntryDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "eventId" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "createdBy" in value;
    isInstance = isInstance && "entityType" in value;
    isInstance = isInstance && "field" in value;
    isInstance = isInstance && "subject" in value;
    isInstance = isInstance && "valueType" in value;

    return isInstance;
}

export function AuditEntryDtoFromJSON(json: any): AuditEntryDto {
    return AuditEntryDtoFromJSONTyped(json, false);
}

export function AuditEntryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEntryDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': json['eventId'],
        'createdAt': (new Date(json['createdAt'])),
        'createdBy': json['createdBy'],
        'entityType': json['entityType'],
        'entityId': !exists(json, 'entityId') ? undefined : json['entityId'],
        'field': json['field'],
        'subject': json['subject'],
        'oldValue': !exists(json, 'oldValue') ? undefined : json['oldValue'],
        'newValue': !exists(json, 'newValue') ? undefined : json['newValue'],
        'valueType': json['valueType'],
        'dictionary': !exists(json, 'dictionary') ? undefined : json['dictionary'],
        'oldValueDisplay': !exists(json, 'oldValueDisplay') ? undefined : json['oldValueDisplay'],
        'newValueDisplay': !exists(json, 'newValueDisplay') ? undefined : json['newValueDisplay'],
    };
}

export function AuditEntryDtoToJSON(value?: AuditEntryDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventId': value.eventId,
        'createdAt': (value.createdAt.toISOString()),
        'createdBy': value.createdBy,
        'entityType': value.entityType,
        'entityId': value.entityId,
        'field': value.field,
        'subject': value.subject,
        'oldValue': value.oldValue,
        'newValue': value.newValue,
        'valueType': value.valueType,
        'dictionary': value.dictionary,
        'oldValueDisplay': value.oldValueDisplay,
        'newValueDisplay': value.newValueDisplay,
    };
}

